<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import * as animateScroll from 'svelte-scrollto'
	import { styles } from '../library/scripts/styles'
	import { url } from '../library/scripts/Setup.svelte'
	import { get_db_entries } from '../builder/builderUtils'
	import { sort_array, remove_duplicates } from '../builder/admin/AdminModule.svelte'
	import {
		storeBuilderPreview,
		storeData,
		storeElementID,
		storeShowTools,
		storeShowDrinks,
	} from '../library/scripts/Store.svelte'

	import IntersectionObserver from 'svelte-intersection-observer'

	const globals = getContext('globals')
	const fsS = globals.fsS
	const devWidth = globals.devWidth
	const devHeight = globals.devHeight
	const isMobi = globals.mobi
	const builderToolbar = globals.builderToolbar
	const builderToolbarHover = globals.builderToolbarHover

	//the folder from which to take images
	let folder

	if (!isMobi) {
		if (devWidth >= 1440) folder = '/large/'
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		if (devWidth < 800) folder = '/small/'
	}

	// mobile devices
	if (isMobi) {
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		else folder = '/small/'
	}

	let elementID
	let isAdmin = false
	let showDrinks

	const stoShowDrinks = storeShowDrinks.subscribe((value) => {
		showDrinks = value
	})

	let showPreview
	const stoPreview = storeBuilderPreview.subscribe((value) => {
		showPreview = value
	})

	let data
	let imagePath

	const stoData = storeData.subscribe((value) => {
		data = value
	})

	if (data.widgets.indexOf('admin') > -1) isAdmin = true

	imagePath = `${url}/`

	//observer
	let element
	const set_observer = (e) => {
		// if (e === 'set' && devHeight > 600) {
		// 	if (!isMobi) element.style.filter = 'blur(5px)'
		// } else if (e !== 'set' && devHeight > 600) {
		// 	element.style.filter = 'blur(0px)'
		// }
	}

	const set_elementID = (e) => {
		storeShowTools.set(true)
		elementID = e
		storeElementID.set(e)
	}

	const show_drinks = () => {
		showDrinks = showDrinks === true ? false : true
		storeShowDrinks.set(showDrinks)
		animateScroll.scrollTo({ element: '#drinkstitle' })
	}

	// create sorted lists after existing categories
	const dbEntries = get_db_entries('drinks')
	let categories = []
	let items = []
	dbEntries.then((value) => {
		value.response.forEach((item) => {
			if (!categories.includes(item.category)) categories.push([item.category, item.menuorder])
			items.push(item)
		})

		categories = remove_duplicates(categories)
		categories = sort_array(categories)
	})

	onDestroy(() => {
		stoPreview
		stoData
		stoShowDrinks
	})
</script>

{#if !showPreview}
	<div
		class="content_row"
		use:styles={{ fsS, builderToolbar, builderToolbarHover }}
		on:click={() => set_elementID('drinks')}
		on:keydown={() => set_elementID('drinks')}
	>
		<div style="margin-left:20px;">*OPEN DRINKS-MENU TOOL*</div>
	</div>
{/if}

{#each data.blocks as block}
	{#if block.blockName === 'drinks'}
		<IntersectionObserver
			{element}
			threshold="0.5"
			on:observe={(e) => {
				if (!e.detail.isIntersecting) {
					set_observer('set')
				} else {
					set_observer('unset')
				}
			}}
		>
			<div
				bind:this={element}
				style="
			background-color: {block.blockBackgroundColor};
            border-top-left-radius: {block.borderTopRadius}px;
			border-top-right-radius: {block.borderTopRadius}px;
            border-bottom-left-radius: {block.borderBottomRadius}px;
			border-bottom-right-radius: {block.borderBottomRadius}px;
            border-left-width: {block.borderLeftWidth}px;
            border-left-style: {block.borderLeftStyle};
            border-left-color: {block.borderLeftColor};
            border-top-width: {block.borderTopWidth}px;
            border-top-style: {block.borderTopStyle};
            border-top-color: {block.borderTopColor};
            border-right-width: {block.borderRightWidth}px;
            border-right-style: {block.borderRightStyle};
            border-right-color: {block.borderRightColor};
            border-bottom-width: {block.borderBottomWidth}px;
            border-bottom-style: {block.borderBottomStyle};
            border-bottom-color: {block.borderBottomColor};
            margin-top: {block.blockMarginTop}%;
            margin-bottom: {block.blockMarginBottom}%;
            padding: {block.blockPadding}%;
            box-shadow:{block.blockBoxShadowX}px {block.blockBoxShadowY}px {block.blockBoxShadowBlur}px {block.blockBoxShadowColor};
			"
			>
				<div
					on:click={show_drinks}
					on:keydown={show_drinks}
					id="drinkstitle"
					style="
				display:flex;
				width: {block.blockTitleWidth}%;
				height: {block.blockTitleHeight}px;
				justify-content:{block.blockTitleAlignHorizontal} ;
				align-items:{block.blockTitleAlignVertical} ;
				font-family:{block.blockTitleFontFamily} ;
				color:{block.blockTitleFontColor} ;
				font-size:{block.blockTitleFontSize} ;
				font-weight:{block.blockTitleFontWeight} ;
				font-style:{block.blockTitleFontStyle} ;
				text-decoration:{block.blockTitleFontDeco} ;
				background-color:{block.blockTitleBackgroundColor} ;
				margin-top:{block.blockTitleMarginTop}% ;
				margin-bottom:{block.blockTitleMarginBottom}% ;
				padding:{block.blockTitlePadding}% ;
				text-shadow:{block.blockTitleShadowOffsetX}px {block.blockTitleShadowOffsetY}px {block.blockTitleShadowBlur}px {block.blockTitleShadowColor};
				cursor:pointer;
				"
				>
					{block.blockTitle}
				</div>

				{#if showDrinks}
					{#await dbEntries then value}
						<div
							style="
							display:flex;
							justify-content:center;
							align-items:center;
							background-color:{block.menuContainerBG};
							margin-top:{block.menuContainerMT}%;
							margin-bottom:{block.menuContainerMB}%;
							padding:{block.menuConatainerP}%;
							width:100%;
							"
						>
							{#if block.menuBGIMG}
								<div
									id="drinks_menu"
									style="
								width:{block.menuWidth}%;
								background-image:url({imagePath}/{block.blockName}/{folder}/{block.menuBGIMG});
								background-size:{block.menuBGS};
								background-repeat:{block.menuBGR};
								padding:{block.blockPadding}%;
								margin-top: {block.menuMT}%;
								margin-bottom:{block.menuMB}%;
								box-shadow: {block.menuSX}px {block.menuSY}px {block.menuSB}px {block.menuSC};
								border-left-width: {block.menuBLW}px;
								border-left-color:{block.menuBLC};
								border-left-style:{block.menuBLS};
								border-top-width: {block.menuBTW}px;
								border-top-color:{block.menuBTC};
								border-top-style:{block.menuBTS};
								border-right-width: {block.menuBRW}px;
								border-right-color:{block.menuBRC};
								border-right-style:{block.menuBRS};
								border-bottom-width: {block.menuBBW}px;
								border-bottom-color:{block.menuBBC};
								border-bottom-style:{block.menuBBS};
								border-top-right-radius:{block.menuBRT}px;
								border-top-left-radius:{block.menuBRT}px;
								border-bottom-left-radius:{block.menuBRB}px;
								border-bottom-right-radius:{block.menuBRB}px;
								padding:{block.menuP}%;
								"
									transition:slide={{ duration: 500 }}
								>
									{#each categories as category}
										<div
											style="
										background-color:{block.categoryBgColor};
										padding:{block.categoryPadding}%; 
										margin-bottom:{block.categoryMargin}%;
										backdrop-filter: blur({block.menuBGB}px);
										webkit-backdrop-filter:blur({block.menuBGB}px);
										"
										>
											<div
												id="drinkscategory"
												style="
											font-size:{block.categoryFontSize};
											font-weight:{block.categoryFontWeight};
											color: {block.categoryFontColor};
											text-decoration:{block.categoryFontDeco};
											font-family: {block.categoryFontFamily};
											font-style:{block.categoryFontStyle};
											
											"
											>
												{category[0]}
											</div>
											{#each items as item (item.id)}
												{#if category[0] === item.category}
													<div
														id="drinksitem"
														class="item_row"
														style="
														font-family:{block.itemFontFamily};
														font-style:{block.itemFontStyle};
														"
													>
														<div
															style="
															font-size:{block.itemFontSize};
															color:{block.itemFontColor};
															"
														>
															{item.item}
														</div>
														<div
															style="
															font-size:{block.itemFontSize};
															color:{block.itemFontColor};
															"
														>
															{item.quantity}
														</div>
														<div
															style="
															font-size:{block.itemFontSize};
															color:{block.itemFontColor};
															"
														>
															{item.currency}
														</div>
														<div
															style="
															font-size:{block.itemFontSize};
															color:{block.itemFontColor};
															"
														>
															{item.price}
														</div>
													</div>
												{/if}
											{/each}
										</div>
									{/each}
								</div>
							{:else}
								<div
									id="drinks_menu"
									style="
								width:{block.menuWidth}%;
								background-color: {block.menuBG};
								box-shadow: {block.menuSX}px {block.menuSY}px {block.menuSB}px {block.menuSC};
								margin-top: {block.menuMT}%;
								margin-bottom:{block.menuMB}%;
								border-left-width: {block.menuBLW}px;
								border-left-color:{block.menuBLC};
								border-left-style:{block.menuBLS};
								border-top-width: {block.menuBTW}px;
								border-top-color:{block.menuBTC};
								border-top-style:{block.menuBTS};
								border-right-width: {block.menuBRW}px;
								border-right-color:{block.menuBRC};
								border-right-style:{block.menuBRS};
								border-bottom-width: {block.menuBBW}px;
								border-bottom-color:{block.menuBBC};
								border-bottom-style:{block.menuBBS};
								border-top-right-radius:{block.menuBRT}px;
								border-top-left-radius:{block.menuBRT}px;
								border-bottom-left-radius:{block.menuBRB}px;
								border-bottom-right-radius:{block.menuBRB}px;
								padding:{block.menuP}%;
							

							"
									transition:slide={{ duration: 500 }}
								>
									{#each categories as category}
										<div
											style="
										background-color:{block.categoryBgColor};
										padding:{block.categoryPadding}%; 
										margin-bottom:{block.categoryMargin}%;
										backdrop-filter: blur({block.menuBGB}px);
										webkit-backdrop-filter:blur({block.menuBGB}px);
										"
										>
											<div
												style="
											font-size:{block.categoryFontSize};
											font-weight:{block.categoryFontWeight};
											font-style:{block.categoryFontStyle};
											color: {block.categoryFontColor};
											text-decoration:{block.categoryFontDeco};
											font-family: {block.categoryFontFamily};
											
											"
											>
												{category[0]}
											</div>
											{#each items as item (item.id)}
												{#if category[0] === item.category}
													<div
														id="drinksitem"
														class="item_row"
														style="
														font-family:{block.itemFontFamily};
														font-style:{block.itemFontStyle};
														"
													>
														<div
															style="
															font-size:{block.itemFontSize};
															color:{block.itemFontColor};
															"
														>
															{item.item}
														</div>
														<div
															style="
															font-size:{block.itemFontSize};
															color:{block.itemFontColor};
															"
														>
															{item.quantity}
														</div>
														<div
															style="
															font-size:{block.itemFontSize};
															color:{block.itemFontColor};
															"
														>
															{item.currency}
														</div>
														<div
															style="
															font-size:{block.itemFontSize};
															color:{block.itemFontColor};
															"
														>
															{item.price}
														</div>
													</div>
												{/if}
											{/each}
										</div>
									{/each}
								</div>
							{/if}
						</div>
					{/await}
				{/if}
			</div>
		</IntersectionObserver>
	{/if}
{/each}

<style>
	.content_row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		cursor: pointer;
		font-style: italic;
		font-size: var(--fsS);
		background-color: var(--builderToolbar);
		height: 40px;
		border-bottom: 1px solid hsl(0, 0%, 50%);
	}

	.content_row:hover {
		background-color: var(--builderToolbarHover);
	}

	/* FOR THE MENU */
	/* .menu_column {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
		grid-gap: 50px;
	} */
	.item_row {
		display: grid;
		grid-template-columns: 55% 15% 15% 15%;
	}
</style>
